/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TEnum
 */
export interface TEnum {
    /**
     * 
     * @type {string}
     * @memberof TEnum
     */
    readonly stringValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TEnum
     */
    $type?: TEnumTypeEnum;
}


/**
 * @export
 */
export const TEnumTypeEnum = {
    PtwI18nLocalizationTEnumPtwI18n: 'Ptw.I18n.Localization.TEnum, Ptw.I18n'
} as const;
export type TEnumTypeEnum = typeof TEnumTypeEnum[keyof typeof TEnumTypeEnum];



/**
 * Check if a given object implements the TEnum interface.
 */
export function instanceOfTEnum(value?: unknown): value is TEnum {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TEnumTypeEnum)[0];
}

export function TEnumFromJSON(json: any): TEnum {
    return TEnumFromJSONTyped(json, false);
}

export function TEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TEnum {
    if (json == null) {
        return json;
    }
    return {
        
        'stringValue': json['stringValue'] == null ? undefined : json['stringValue'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TEnumToJSON(value?: Omit<TEnum, 'stringValue'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value['$type'],
    });
}

